import api from '@/api';
import { API_BASE_URL } from '..';
import {
  StoneOrderCancelRequest,
  StoneOrderCreateRequest,
  StoneOrderCreateResponse,
  StoneOrderHasOpenOrderResponse,
} from './orders.types';

const CONTROLLER = `${API_BASE_URL}/order`;

export default {
  async hasOpenOrder(deviceId?: number) {
    const result = (await api.get(
      `${CONTROLLER}/hasOpenOrder/${deviceId}`,
      null,
    )) as unknown;

    return result as StoneOrderHasOpenOrderResponse;
  },

  async create(data: StoneOrderCreateRequest) {
    const result = (await api.post(CONTROLLER, data)) as unknown;

    return result as StoneOrderCreateResponse;
  },

  async cancel(params: StoneOrderCancelRequest) {
    const result = (await api.put(
      `${CONTROLLER}/${params.orderId}/cancel`,
      {},
      null,
    )) as unknown;

    return result as void;
  },
};
